module.exports = {"BASE_API_URL":"https://api.staging.dada.nyc/"}


//////////////////
// WEBPACK FOOTER
// ./src/config.json
// module id = 976
// module chunks = 1